class MessageCardManager {
  constructor(container) {
    this.container = container;
    this.lineNumber = container.dataset.line || '';
    // Find all card groups for this product (one per quantity)
    this.cardGroups = Array.from(container.querySelectorAll('.cart-attribute__card-group'));
    this.cardGroups.forEach((group, idx) => {
      const i = idx + 1;
      // Message card radios
      const cardRadios = group.querySelectorAll(
        `input[name="properties[メッセージカード選択_${this.lineNumber}_${i}]"]`
      );
      // Design radios
      const designRadios = group.querySelectorAll(`input[name="properties[デザインパターン_${this.lineNumber}_${i}]"]`);
      // Textarea
      const textarea = group.querySelector(
        `textarea[name="properties[ギフトカードメッセージ_${this.lineNumber}_${i}]"]`
      );
      // Conditional section
      const conditionalSection = group.querySelector('.cart-attribute__conditional-section');
      // Char count
      const charCount = group.querySelector(`#char-count-${this.lineNumber}_${i}`);
      // Preview button
      const previewButton = group.querySelector(`#PreviewButton-${this.lineNumber}_${i}`);
      // Preview modal
      const previewModal = group.querySelector(`#MessageCardPreview-${this.lineNumber}_${i}`);
      // Close button
      const closeButton = group.querySelector(`#ClosePreview-${this.lineNumber}_${i}`);
      // Preview card
      const previewCard = group.querySelector(`#PreviewCard-${this.lineNumber}_${i}`);
      // Magnify buttons
      const magnifyButtons = group.querySelectorAll('.cart-attribute__magnify-icon');
      // Show/hide conditional section
      cardRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.value === 'あり') {
            conditionalSection.style.display = 'block';
            conditionalSection.classList.add('visible');
          } else {
            conditionalSection.style.display = 'none';
            conditionalSection.classList.remove('visible');
            if (textarea) textarea.value = '';
            designRadios.forEach((d) => {
              d.checked = false;
            });
          }
          // Update cart attribute
          const cartAttr = document.querySelector(
            `input[name="attributes[メッセージカード_商品${this.lineNumber}_数量${i}]"]`
          );
          if (cartAttr) cartAttr.value = radio.value;

          // Save to localStorage
          const designRadio = group.querySelector(
            `input[name="properties[デザインパターン_${this.lineNumber}_${i}]"]:checked`
          );
          const message = textarea ? textarea.value : '';
          messageCardStorage.save(this.lineNumber, i, radio.value, designRadio ? designRadio.value : '', message);
        });

        const initialCardRadio = group.querySelector(
          `input[name="properties[メッセージカード選択_${this.lineNumber}_${i}]"]:checked`
        );
        // Initial state
        if (initialCardRadio && initialCardRadio.value === 'あり') {
          conditionalSection.style.display = 'block';
          conditionalSection.classList.add('visible');
        }
      });
      // Design radio change
      designRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const cartAttr = document.querySelector(`input[name="attributes[デザイン_商品${this.lineNumber}_数量${i}]"]`);
          if (cartAttr) cartAttr.value = radio.value;

          // Save to localStorage
          const cardRadio = group.querySelector(
            `input[name="properties[メッセージカード選択_${this.lineNumber}_${i}]"]:checked`
          );
          const message = textarea ? textarea.value : '';
          messageCardStorage.save(this.lineNumber, i, cardRadio ? cardRadio.value : 'なし', radio.value, message);
        });

        const initialDesignRadio = group.querySelector(
          `input[name="properties[デザインパターン_${this.lineNumber}_${i}]"]:checked`
        );
      });
      // Textarea input
      if (textarea) {
        textarea.addEventListener('input', () => {
          if (charCount) {
            const charCountWithoutNewlines = textarea.value.replace(/\n/g, '').length;
            charCount.textContent = charCountWithoutNewlines;
          }
          const cartAttr = document.querySelector(
            `input[name="attributes[メッセージ_商品${this.lineNumber}_数量${i}]"]`
          );
          if (cartAttr) cartAttr.value = textarea.value;

          // Save to localStorage
          const cardRadio = group.querySelector(
            `input[name="properties[メッセージカード選択_${this.lineNumber}_${i}]"]:checked`
          );
          const designRadio = group.querySelector(
            `input[name="properties[デザインパターン_${this.lineNumber}_${i}]"]:checked`
          );
          messageCardStorage.save(
            this.lineNumber,
            i,
            cardRadio ? cardRadio.value : 'なし',
            designRadio ? designRadio.value : '',
            textarea.value
          );
        });

        // hidden input は不要（properties はチェックアウト時の再構築で送信）
      }
      // Preview button (single design: show message only)
      if (previewButton && previewModal && previewCard) {
        previewButton.addEventListener('click', (e) => {
          e.preventDefault();
          previewModal.hidden = false;
          document.body.style.overflow = 'hidden';
          document.body.classList.add('modal-open');

          // Hide cart footer elements while modal is open
          const cartFooter = document.getElementById('shopify-section-cart-footer');
          const mainCartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.style.display = 'none';
          if (mainCartFooter) mainCartFooter.style.display = 'none';

          // Render message only (design is fixed)
          const messageText = textarea?.value || '';
          const designElement = previewCard.querySelector('.preview-card__design');
          const messageElement = previewCard.querySelector('.preview-card__message');
          if (designElement) {
            designElement.style.display = 'none';
            designElement.textContent = '';
          }
          if (messageElement) {
            // Preserve line breaks in preview
            messageElement.textContent = messageText || 'メッセージが入力されていません';
            messageElement.style.whiteSpace = 'pre-wrap';
            messageElement.style.wordBreak = 'break-all';
            messageElement.style.overflowWrap = 'break-word';
          }
        });
      }
      // Close preview
      if (closeButton && previewModal) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          previewModal.hidden = true;
          document.body.style.overflow = '';
          document.body.classList.remove('modal-open');

          // Restore cart footer elements
          const cartFooter = document.getElementById('shopify-section-cart-footer');
          const mainCartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.style.display = '';
          if (mainCartFooter) mainCartFooter.style.display = '';
        });
      }
      // Magnify icon removed: design selection is no longer used
    });
  }
}

// Storage for message card selections with localStorage persistence and cart token validation
const messageCardStorage = {
  storageKey: 'shopify_message_cards',
  cartIdKey: 'shopify_cart_token',
  isRestoring: false,

  loadFromLocalStorage() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error('Error loading message card data:', error);
      return {};
    }
  },

  saveToLocalStorage(data) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving message card data:', error);
    }
  },

  async getCurrentCartToken() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.token || '';
    } catch (error) {
      console.error('Error getting cart token:', error);
      return '';
    }
  },

  async validateCartToken() {
    const storedToken = localStorage.getItem(this.cartIdKey);
    const currentToken = await this.getCurrentCartToken();

    if (!currentToken || storedToken !== currentToken) {
      this.clear();
      localStorage.setItem(this.cartIdKey, currentToken);
      return false;
    }

    return true;
  },

  getVariantId(lineNumber) {
    const container = document.querySelector(`.cart__attributes[data-line="${lineNumber}"]`);
    if (!container) return null;

    const quantityInput = document.querySelector(`#Quantity-${lineNumber}`);
    return quantityInput?.dataset?.quantityVariantId || null;
  },

  save(lineNumber, quantityIndex, cardSelection, design, message) {
    if (this.isRestoring) return;

    const variantId = this.getVariantId(lineNumber);
    if (!variantId) return;

    const data = this.loadFromLocalStorage();
    const key = `${variantId}_${quantityIndex}`;
    data[key] = {
      cardSelection: cardSelection || 'なし',
      design: design || '',
      message: message || '',
      variantId: variantId,
      timestamp: Date.now(),
    };
    this.saveToLocalStorage(data);
  },

  get(lineNumber, quantityIndex) {
    const variantId = this.getVariantId(lineNumber);
    if (!variantId) return null;

    const data = this.loadFromLocalStorage();
    const key = `${variantId}_${quantityIndex}`;
    return data[key] || null;
  },

  clear() {
    try {
      localStorage.removeItem(this.storageKey);
      localStorage.removeItem(this.cartIdKey);
    } catch (error) {
      console.error('Error clearing message card data:', error);
    }
  },

  saveAll() {
    try {
      const containers = document.querySelectorAll('.cart__attributes');
      containers.forEach((container) => {
        const lineNumber = container.dataset.line || '';
        const cardGroups = container.querySelectorAll('.cart-attribute__card-group');

        cardGroups.forEach((group, idx) => {
          const i = idx + 1;

          // Get card selection
          const cardRadio = group.querySelector(
            `input[name="properties[メッセージカード選択_${lineNumber}_${i}]"]:checked`
          );
          const cardSelection = cardRadio ? cardRadio.value : 'なし';

          // Get design selection
          const designRadio = group.querySelector(
            `input[name="properties[デザインパターン_${lineNumber}_${i}]"]:checked`
          );
          const design = designRadio ? designRadio.value : '';

          // Get message
          const textarea = group.querySelector(
            `textarea[name="properties[ギフトカードメッセージ_${lineNumber}_${i}]"]`
          );
          const message = textarea ? textarea.value : '';

          this.save(lineNumber, i, cardSelection, design, message);
        });
      });
    } catch (error) {
      console.error('Error in saveAll:', error);
    }
  },

  restoreAll() {
    if (this.isRestoring) return;

    this.isRestoring = true;

    try {
      const containers = document.querySelectorAll('.cart__attributes');
      containers.forEach((container) => {
        const lineNumber = container.dataset.line || '';
        const cardGroups = container.querySelectorAll('.cart-attribute__card-group');

        cardGroups.forEach((group, idx) => {
          const i = idx + 1;
          const saved = this.get(lineNumber, i);

          if (saved) {
            // Restore card selection
            const cardRadios = group.querySelectorAll(
              `input[name="properties[メッセージカード選択_${lineNumber}_${i}]"]`
            );
            for (const radio of cardRadios) {
              if (radio.value === saved.cardSelection) {
                radio.checked = true;
                const conditionalSection = group.querySelector('.cart-attribute__conditional-section');
                if (radio.value === 'あり' && conditionalSection) {
                  conditionalSection.style.display = 'block';
                  conditionalSection.classList.add('visible');
                } else if (conditionalSection) {
                  conditionalSection.style.display = 'none';
                  conditionalSection.classList.remove('visible');
                }
                // Update cart attribute for card selection
                const cartAttr = document.querySelector(
                  `input[name="attributes[メッセージカード_商品${lineNumber}_数量${i}]"]`
                );
                if (cartAttr) cartAttr.value = saved.cardSelection;

                break;
              }
            }

            // Restore design selection
            if (saved.design) {
              const designRadios = group.querySelectorAll(
                `input[name="properties[デザインパターン_${lineNumber}_${i}]"]`
              );
              for (const radio of designRadios) {
                if (radio.value === saved.design) {
                  radio.checked = true;
                  // Update cart attribute for design
                  const cartAttr = document.querySelector(
                    `input[name="attributes[デザイン_商品${lineNumber}_数量${i}]"]`
                  );
                  if (cartAttr) cartAttr.value = saved.design;

                  break;
                }
              }
            }

            // Restore message
            if (saved.message) {
              const textarea = group.querySelector(
                `textarea[name="properties[ギフトカードメッセージ_${lineNumber}_${i}]"]`
              );
              if (textarea) {
                textarea.value = saved.message;
                const charCount = group.querySelector(`#char-count-${lineNumber}_${i}`);
                if (charCount) {
                  const charCountWithoutNewlines = textarea.value.replace(/\n/g, '').length;
                  charCount.textContent = charCountWithoutNewlines;
                }
                // Update cart attribute for message
                const cartAttr = document.querySelector(
                  `input[name="attributes[メッセージ_商品${lineNumber}_数量${i}]"]`
                );
                if (cartAttr) cartAttr.value = saved.message;
              }
            }
          }
        });
      });
    } catch (error) {
      console.error('Error in restoreAll:', error);
    } finally {
      this.isRestoring = false;
    }
  },
};

// Function to initialize all message card managers
const initializeMessageCardManagers = () => {
  try {
    const containers = document.querySelectorAll('.cart__attributes');
    containers.forEach((container) => {
      if (!container.dataset.initialized) {
        new MessageCardManager(container);
        container.dataset.initialized = 'true';
      }
    });
  } catch (error) {
    console.error('Error initializing MessageCardManager:', error);
  }
};

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', async () => {
  // Validate cart token and clear stale data
  await messageCardStorage.validateCartToken();

  initializeMessageCardManagers();

  // Restore saved data from localStorage on page load
  setTimeout(() => {
    messageCardStorage.restoreAll();
  }, 50);

  // Set up MutationObserver to watch for cart DOM changes
  const cartItemsContainer = document.getElementById('main-cart-items');
  if (cartItemsContainer) {
    let isUpdating = false;

    const observer = new MutationObserver((mutations) => {
      if (isUpdating) return;

      const hasSignificantChange = mutations.some((mutation) => {
        if (mutation.type !== 'childList') return false;

        const hasAddedNodes = mutation.addedNodes.length > 0;
        const hasRemovedNodes = mutation.removedNodes.length > 0;

        if (!hasAddedNodes && !hasRemovedNodes) return false;

        for (const node of mutation.addedNodes) {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            (node.classList?.contains('cart-item') || node.querySelector?.('.cart-item'))
          ) {
            return true;
          }
        }

        for (const node of mutation.removedNodes) {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            (node.classList?.contains('cart-item') || node.querySelector?.('.cart-item'))
          ) {
            return true;
          }
        }

        return false;
      });

      if (!hasSignificantChange) return;

      isUpdating = true;

      const containers = document.querySelectorAll('.cart__attributes');
      containers.forEach((container) => {
        delete container.dataset.initialized;
      });

      setTimeout(() => {
        initializeMessageCardManagers();
        messageCardStorage.restoreAll();
        isUpdating = false;
      }, 100);
    });

    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true,
    });
  }
});

// Reinitialize after cart updates
document.addEventListener('cart:updated', () => {
  try {
    const containers = document.querySelectorAll('.cart__attributes');
    containers.forEach((container) => {
      delete container.dataset.initialized;
    });

    setTimeout(() => {
      initializeMessageCardManagers();
      messageCardStorage.restoreAll();
    }, 150);
  } catch (error) {
    console.error('Error reinitializing MessageCardManager after cart update:', error);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('cart');
  if (!form) return;
  // 共通バリデーション関数（フォーム送信・ゲストチェックアウトで共用）
  const validateMessageCardRequirements = () => {
    // 既存のエラーメッセージを一旦クリア
    document.querySelectorAll('.cart-attribute__error-message').forEach((el) => el.remove());

    const cartAttributeContainers = document.querySelectorAll('.cart__attributes');
    let hasError = false;

    cartAttributeContainers.forEach((container) => {
      const lineNumber = container.dataset.line || '';
      const cardGroups = container.querySelectorAll('.cart-attribute__card-group');

      cardGroups.forEach((group, idx) => {
        const i = idx + 1;

        // メッセージカード選択の確認
        const cardRadio = group.querySelector(
          `input[name="properties[メッセージカード選択_${lineNumber}_${i}]"]:checked`
        );
        if (!cardRadio || cardRadio.value !== 'あり') {
          // 「なし」の場合は検証不要
          return;
        }

        // メッセージ必須
        const messageBox = group.querySelector(
          `textarea[name="properties[ギフトカードメッセージ_${lineNumber}_${i}]"]`
        );
        if (messageBox && (messageBox.value || '').trim() === '') {
          messageBox.classList.add('error');
          const err = document.createElement('div');
          err.className = 'cart-attribute__error-message';
          err.textContent = 'メッセージカードを選択した場合、メッセージの入力が必要です。';
          messageBox.parentNode.appendChild(err);
          hasError = true;
        }

        // デザイン必須（デザイン選択が表示されている場合のみ）
        const designRadios = group.querySelectorAll(`input[name="properties[デザインパターン_${lineNumber}_${i}]"]`);
        if (designRadios && designRadios.length > 0) {
          const designRadioChecked = group.querySelector(
            `input[name="properties[デザインパターン_${lineNumber}_${i}]"]:checked`
          );
          if (!designRadioChecked) {
            const designField = group.querySelector('.cart-attribute__design-grid');
            if (designField) {
              const err = document.createElement('div');
              err.className = 'cart-attribute__error-message';
              err.textContent = 'デザインを選択してください。';
              designField.parentNode.appendChild(err);
            }
            hasError = true;
          }
        }
      });
    });

    // カート全体の状態用クラスの更新
    const anyContainer = document.querySelector('.cart__attributes');
    if (anyContainer) {
      if (hasError) anyContainer.classList.add('has-validation-error');
      else anyContainer.classList.remove('has-validation-error');
    }

    return hasError;
  };

  // フォーム送信時のバリデーション
  form.addEventListener('submit', function (e) {
    const hasError = validateMessageCardRequirements();
    if (hasError) {
      e.preventDefault();
      // エラーメッセージを集約（必要に応じて動的に表示）
      const messages = [];
      const anyContainer = document.querySelector('.cart__attributes');
      if (anyContainer) {
        if (anyContainer.querySelector('textarea.cart-attribute__textarea.error')) {
          messages.push('メッセージカードを選択した場合、メッセージの入力が必要です。');
        }
        const hasDesignError = Array.from(anyContainer.querySelectorAll('.cart-attribute__error-message')).some((n) =>
          n.textContent.includes('デザインを選択してください。')
        );
        if (hasDesignError) messages.push('デザインを選択してください。');
      }
      alert(messages.join('\n'));
    }
  });
  const textareas = form.querySelectorAll('.cart-attribute__textarea');
  textareas.forEach((messageBox) => {
    messageBox.addEventListener('input', function () {
      messageBox.classList.remove('error');
      const container = messageBox.closest('.cart__attributes');
      const errorMsg = messageBox.parentNode.querySelector('.cart-attribute__error-message');
      if (errorMsg) errorMsg.remove();

      // Update validation state
      if (container) {
        const hasOtherErrors = container.querySelector('.cart-attribute__error-message');
        if (!hasOtherErrors) {
          container.classList.remove('has-validation-error');
        }
      }
    });
  });

  // ゲストチェックアウトボタンのクリックもバリデーション
  const guestCheckoutBtn = document.querySelector('.guest-checkout-btn');
  if (guestCheckoutBtn) {
    guestCheckoutBtn.addEventListener('click', function (e) {
      const hasError = validateMessageCardRequirements();
      if (hasError) {
        e.preventDefault();
        e.stopPropagation();
        // 動的メッセージ
        const messages = [];
        const anyContainer = document.querySelector('.cart__attributes');
        if (anyContainer) {
          if (anyContainer.querySelector('textarea.cart-attribute__textarea.error')) {
            messages.push('メッセージカードを選択した場合、メッセージの入力が必要です。');
          }
          const hasDesignError = Array.from(anyContainer.querySelectorAll('.cart-attribute__error-message')).some((n) =>
            n.textContent.includes('デザインを選択してください。')
          );
          if (hasDesignError) messages.push('デザインを選択してください。');
        }
        alert(messages.join('\n'));
      }
    });

    // ボタンを囲むアンカー（/checkout 直リンク）がある場合もクリックを抑止
    const guestAnchor = guestCheckoutBtn.closest('a[href]');
    if (guestAnchor) {
      guestAnchor.addEventListener('click', function (e) {
        const hasError = validateMessageCardRequirements();
        if (hasError) {
          e.preventDefault();
          e.stopPropagation();
          alert('メッセージカードを選択した場合、メッセージの入力が必要です。');
        }
      });
    }
  }

  // カート通知（ミニカート）のチェックアウトフォームにも適用
  const cartNotificationForm = document.getElementById('cart-notification-form');
  if (cartNotificationForm) {
    cartNotificationForm.addEventListener('submit', function (e) {
      const hasError = validateMessageCardRequirements();
      if (hasError) {
        e.preventDefault();
        const messages = [];
        const anyContainer = document.querySelector('.cart__attributes');
        if (anyContainer) {
          if (anyContainer.querySelector('textarea.cart-attribute__textarea.error')) {
            messages.push('メッセージカードを選択した場合、メッセージの入力が必要です。');
          }
          const hasDesignError = Array.from(anyContainer.querySelectorAll('.cart-attribute__error-message')).some((n) =>
            n.textContent.includes('デザインを選択してください。')
          );
          if (hasDesignError) messages.push('デザインを選択してください。');
        }
        alert(messages.join('\n'));
      }
    });
  }

  // Handle all design radio buttons with their unique names
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name^="properties[デザインパターン"]')) {
      const radio = event.target;
      const container = radio.closest('.cart__attributes');
      const designField = container ? container.querySelector('.cart-attribute__design-grid') : null;
      const errorMsg =
        designField && designField.parentNode
          ? designField.parentNode.querySelector('.cart-attribute__error-message')
          : null;
      if (errorMsg) errorMsg.remove();

      // Update validation state
      if (container) {
        const hasOtherErrors = container.querySelector('.cart-attribute__error-message');
        if (!hasOtherErrors) {
          container.classList.remove('has-validation-error');
        }
      }
    }
  });
});

// Message card textarea validation
document.addEventListener('DOMContentLoaded', () => {
  const textareas = document.querySelectorAll('.cart-attribute__textarea');

  for (const textarea of textareas) {
    const charCountSpan = textarea.parentElement.querySelector('.cart-attribute__char-count span');

    if (!charCountSpan) continue;

    const maxLineLength = parseInt(textarea.dataset.maxLineLength) || 30;
    const maxLines = parseInt(textarea.dataset.maxLines) || 5;

    // Update character count on input
    textarea.addEventListener('input', (e) => {
      const lines = textarea.value.split('\n');
      let modified = false;
      const processedLines = [];

      // Process each line for auto-wrapping and line count limit
      for (const line of lines) {
        if (line.length <= maxLineLength) {
          processedLines.push(line);
        } else {
          // Auto-wrap long lines into multiple lines
          for (let i = 0; i < line.length; i += maxLineLength) {
            processedLines.push(line.substring(i, i + maxLineLength));
          }
          modified = true;
        }
      }

      // Limit to max lines
      if (processedLines.length > maxLines) {
        processedLines.splice(maxLines);
        modified = true;
      }

      if (modified) {
        const newValue = processedLines.join('\n');
        const cursorPos = Math.min(textarea.selectionStart, newValue.length);
        textarea.value = newValue;
        textarea.setSelectionRange(cursorPos, cursorPos);
      }

      // Count characters excluding line breaks
      const charCountWithoutNewlines = textarea.value.replace(/\n/g, '').length;
      charCountSpan.textContent = charCountWithoutNewlines;
    });

    // Handle paste events
    textarea.addEventListener('paste', (e) => {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      const lines = paste.split('\n').slice(0, maxLines);

      for (let i = 0; i < lines.length; i++) {
        if (lines[i].length > maxLineLength) {
          lines[i] = lines[i].substring(0, maxLineLength);
        }
      }

      const newText = lines.join('\n');
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const currentValue = textarea.value;

      const beforeText = currentValue.substring(0, start);
      const afterText = currentValue.substring(end);
      const combinedText = beforeText + newText + afterText;

      const combinedLines = combinedText.split('\n').slice(0, maxLines);
      for (let i = 0; i < combinedLines.length; i++) {
        if (combinedLines[i].length > maxLineLength) {
          combinedLines[i] = combinedLines[i].substring(0, maxLineLength);
        }
      }

      textarea.value = combinedLines.join('\n');

      const newCursorPos = start + newText.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);

      textarea.dispatchEvent(new Event('input'));
    });

    // Handle Enter key to prevent exceeding max lines and count newline in char limit
    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const lines = textarea.value.split('\n');

        // Prevent exceeding max lines
        if (lines.length >= maxLines) {
          e.preventDefault();
          return;
        }

        // Check if adding a newline would exceed total character limit
        const maxLength = parseInt(textarea.getAttribute('maxlength')) || 150;
        if (textarea.value.length >= maxLength) {
          e.preventDefault();
          return;
        }

        // Allow the Enter key and manually insert newline
        e.preventDefault();
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const value = textarea.value;

        textarea.value = value.substring(0, start) + '\n' + value.substring(end);
        textarea.setSelectionRange(start + 1, start + 1);

        // Trigger input event to update char count
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
});
